<template>
  <div>
  <v-card-text class="pa-0" style="height: 600px; overflow-y: auto;">
    <v-layout class="pa-2" row wrap style="height: auto;" v-if="logs">
      <v-flex xs12>
      <v-data-table :headers="headers" :items="sorted_logs" hide-actions disable-initial-sort>
      <template slot="items" slot-scope="props">
        <td style="min-width: 250px;">{{props.item.meta.comment}}</td>
        <td>{{get_content(props.item.device_data.status, "name")}}</td>
        <td>{{get_content(props.item.device_data.location, "name")}}</td>
        <td>{{get_account(props.item.account_id)}}</td>
        <td>{{format_date(props.item.updated_at)}}</td>
        <td class="hidden-sm-and-down" style="text-align: right; min-width: 50px; max-width: 50px; width: 50px;">
        </td>
      </template>
    </v-data-table>
    </v-flex>

    </v-layout>
    </v-card-text>
    <v-card-actions style="background-color: #3A3A3A; min-height: 85px;">
      <log :id="id" ref="log" style="width: 100%;"></log>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>
<script>
import moment from 'moment';
import Log from './Log'

export default {
  props: ["id"],
  components: {
    Log
  },
  data () {
    var ch = {};
    if (typeof(this.id) != "undefined") {
      ch = this.$cloudserver.channel("devices:logs:"+this.id);
    }
    return {
      ws_channel: ch,
      logs: this.convertLogs(ch.data),
      device_log: {meta: {}},
      headers: [
        { text: 'Comment', value: 'meta.comment', align: 'left' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Location', value: 'location', align: 'left'},
        { text: 'Creator', value: 'creator', align: 'left' },
        { text: 'Date', value: 'date', align: 'left'},  
        { text: 'Actions', align: 'right', class: "hidden-sm-and-down"}

      ],  
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.logs = this.convertLogs(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        if (typeof(this.id) != "undefined") {
          this.ws_channel = this.$cloudserver.channel("devices:logs:"+this.id);
          this.ws_channel.join();
        }
      }
    }
  },  
  created() {
    if (typeof(this.id) != "undefined") {
      this.ws_channel.join();
    }
  },
  computed: {
    sorted_logs() {
      var sorted = _.sortBy(this.logs, function(log) {
        var d = moment.utc(log.updated_at).local();
        return d.format("X");
      });
      return _.reverse(sorted);
    }
  },
  methods: {
    get_type_title(type) {
      return type;
    },
    get_content(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field.data[name];
      }
      return "";
    },
    get_account(id) {
      return this.$store.state.accounts[id].email;
    },
    format_date(date) {
      var d = moment.utc(date).local();
      return d.format("DD.MM.YYYY HH:mm");
    },
    convertLogs (newVal, oldVal) {
      var logs = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      if(typeof(logs) == "undefined" || _.isEmpty(logs)) return undefined;
      return logs;
    },
    save (close) {
      this.$refs.log.save(close);

    }
  }
}
</script>